import { render, staticRenderFns } from "./stockMovement.vue?vue&type=template&id=f466e6ec&"
import script from "./stockMovement.vue?vue&type=script&lang=js&"
export * from "./stockMovement.vue?vue&type=script&lang=js&"
import style0 from "./stockMovement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports